import { Consultation, ConsultationCard, PagedList } from '../../types';
import { MapConstraintDetail } from '../../types/MapConstraintDetail';

export const MOCK_CONSULTATION_CARD: ConsultationCard = {
  id: 1,
  status: 'Closed',
  consultationType: 'Statutory',
  category: 'Regionally significant',
  assigneeId: 1,
  assignee: 'Bill Zuma',
  authority: 'Antrim and newtonabey borough council',
  address: 'Land off Rugby Road and Coventry Road, Newtonabbey, BT32 7JN',
  reference: 'LA09/2021/0613/F',
  summaryDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ullamcorper ut ipsum ut iaculis. Donec iaculis ligula quis augue vulputate, et tincidunt tellus rutrum. Vivamus in pellentesque lacus, sit amet dapibus sapien. Curabitur efficitur laoreet nibh non dignissim. Suspendisse aliquet et nisl id bibendum. Fusce finibus, lorem vel accumsan venenatis, quam nunc scelerisque mauris, et placerat nunc enim tempus lacus. Nulla ultricies odio non aliquam elementum. Nullam eget tempor tortor. Donec tincidunt pellentesque sapien, sed feugiat dolor sodales et. Donec ornare sollicitudin maximus. Quisque consequat efficitur arcu, a sodales ligula ultrices eu. In at mauris id est imperdiet vulputate tristique eget massa. Curabitur id auctor quam. Sed scelerisque libero et odio accumsan fermentum.',
  requestedDate: new Date('2022-01-01'),
  deadlineDate: new Date(`${new Date().getFullYear() + 1}-12-31`),
  hasAnyResponses: true,
  isArchived: false,
};

export const MOCK_CONSULTATION_CARD_RPC: ConsultationCard = {
  ...MOCK_CONSULTATION_CARD,
  address: 'Rathfriland Baptist Church Loughbrickland Road Rathfriland Down BT34 5BY',
  consultationType: 'RPC',
  id: 2,
};

export const MOCK_CONSTRAINT: MapConstraintDetail = {
  constraintCode: 'VenTestCode1',
  constraintName: 'Ven Constraint 1',
  description: 'Affected Constraint Description 1',
  enabled: true,
  id: 1081,
  tenantId: 'cfb86436-414d-4459-9545-93eec37615a2',
};

export const MOCK_SORT_OPTIONS = {
  sortOptions: [
    {
      value: '1',
      label: 'Date requested',
    },
    {
      value: '2',
      label: 'Furthest deadline',
    },
    {
      value: '3',
      label: 'Nearest deadline',
    },
    {
      value: '4',
      label: 'Date requested',
    },
  ],
};

export const MOCK_CONSULTATION: Consultation = {
  ...MOCK_CONSULTATION_CARD,
  lastVisitedDate: new Date('2022-01-15'),
  lastVisitedConsulteeId: 11,
  lastVisitedBy: 'Sophie Jones',
  reasonForConsultation: '',
  summaryDescription: MOCK_CONSULTATION_CARD.summaryDescription,
  uprn: '123456789012',
  caseOfficerName: 'Bruce Banner',
  caseOfficerContactNumber: '07777 123456',
  caseOfficerContactEmail: 'email@example.com',
  hasExtensionRequest: false,
  hasAnyResponses: true,
  lastRespondedDate: new Date('2022-01-15 01:00:00'),
  lastRespondedConsulteeId: 11,
  lastRespondedBy: 'Sophie Jones',
  isArchived: false,
  notes: [
    {
      id: 1,
      noteDate: new Date('2029-12-31 01:00:00'),
      noteText: 'Case details updated',
      noteType: 'Internal',
      consulteeName: 'Ted Barnes',
    },
  ],
  questions: [
    {
      id: 1,
      questionNumber: 2,
      text: 'Are there any proposals for road works which may affect the property?',
      defaultAnswer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt rutrum rhoncus. Aliquam nec volutpat nisi. Nulla facilisi. Nunc sed leo quis augue accumsan aliquet sit amet vel tellus 1',
    },
  ],
  consultationMapConstraintDetails: [MOCK_CONSTRAINT],
};

export const MOCK_CONSULTATION_WITHOUT_CONSTRAINTS: Consultation = {
  ...MOCK_CONSULTATION,
  consultationMapConstraintDetails: [],
};

export const MOCK_CONSULTATION_WITHOUT_NOTES: Consultation = {
  ...MOCK_CONSULTATION,
  notes: [],
  questions: [],
};

export const MOCK_CONSULTATION_HAS_EXTENSION_REQUEST: Consultation = {
  ...MOCK_CONSULTATION,
  hasExtensionRequest: true,
};

export const MOCK_CONSULTATION_ASSIGNED_ANOTHER: Consultation = {
  ...MOCK_CONSULTATION,
  assigneeId: 100,
};

export const MOCK_CONSULTATION_ARCHIVED: Consultation = {
  ...MOCK_CONSULTATION,
  isArchived: true,
};

export const MOCK_CONSULTATION_RPC: Consultation = {
  ...MOCK_CONSULTATION,
  id: 2,
  consultationType: 'RPC',
};

export const MOCK_CONSULTATION_OVERDUE: Consultation = {
  ...MOCK_CONSULTATION,
  status: 'Overdue',
  deadlineDate: new Date('2022-01-01'),
};

export const MOCK_CONSULTATION_RPC_OVERDUE: Consultation = {
  ...MOCK_CONSULTATION_RPC,
  status: 'Overdue',
  deadlineDate: new Date('2022-01-01'),
};

export const MOCK_CONSULTATION_WITH_ASSIGNEE_VISITOR_MATCH: Consultation = {
  ...MOCK_CONSULTATION,
  lastVisitedConsulteeId: 1,
  lastVisitedBy: 'Bill Zuma',
};

export const MOCK_CONSULTATIONS: PagedList<ConsultationCard> = {
  items: [MOCK_CONSULTATION_CARD, MOCK_CONSULTATION_CARD_RPC],
};

export const MOCK_CONSULTATIONS_PAGE1: PagedList<ConsultationCard> = {
  items: [
    MOCK_CONSULTATION_CARD,
    MOCK_CONSULTATION_CARD_RPC,
    MOCK_CONSULTATION_CARD,
    MOCK_CONSULTATION_CARD_RPC,
    MOCK_CONSULTATION_CARD,
    MOCK_CONSULTATION_CARD_RPC,
    MOCK_CONSULTATION_CARD,
    MOCK_CONSULTATION_CARD_RPC,
    MOCK_CONSULTATION_CARD,
    MOCK_CONSULTATION_CARD_RPC,
  ],
};

export const MOCK_CONSULTATIONS_PAGE2: PagedList<ConsultationCard> = {
  items: [MOCK_CONSULTATION_CARD, MOCK_CONSULTATION_CARD_RPC],
};

export const MOCK_CONSULTATIONS_NONE: PagedList<ConsultationCard> = {
  items: [],
};
